import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SCROLL_OFFSET = 100;

const scrollToElement = element => {
  const isScrollToOptionsSupported =
    'scrollBehavior' in document.documentElement.style;
  const scrollPosition = element.offsetTop - SCROLL_OFFSET;

  if (isScrollToOptionsSupported) {
    window.scrollTo({
      top: scrollPosition,
      left: 0,
      behavior: 'smooth',
    });
  } else {
    window.scrollTo(0, scrollPosition);
  }
};

const useScrollToHash = () => {
  const location = useLocation();
  const windowIsReady = typeof window !== 'undefined';

  useEffect(() => {
    if (!windowIsReady) return;

    if (location.hash) {
      const hashWithoutPoundSign = location.hash.substring(1);
      const element = document.getElementById(hashWithoutPoundSign);
      element && scrollToElement(element);
    }
  }, [windowIsReady]);
};

export default useScrollToHash;
